var map = {
	"./bg.png": "dc97",
	"./logo.png": "4ffd",
	"./logo/Octocat.png": "170a",
	"./logo/azure.svg": "8c16",
	"./logo/css.png": "ff8f",
	"./logo/gql.svg": "c61f",
	"./logo/html.png": "c0f0",
	"./logo/laravel.png": "4d28",
	"./logo/linux.png": "644b",
	"./logo/mongo.svg": "4c7b",
	"./logo/mysql.svg": "a3a5",
	"./logo/node.svg": "7b60",
	"./logo/nuxt.svg": "b4c0",
	"./logo/ovh.png": "4c20",
	"./logo/rabbit.svg": "659c",
	"./logo/sym.svg": "b8a7",
	"./logo/vuejs.png": "7b0b0",
	"./photo.jpg": "1e22"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";